import { Box, Typography } from "@mui/material";
import { DashboardCard } from "@pages:app/analytics/components/cards/DashboardCard";
import { ReactNode } from "react";

type StatCardProps = {
  label: string;
  value: number | string | undefined;
  icon?: ReactNode;
  colSpan?: number;
  rowSpan?: number;
  format?: (value: number) => string;
};

const formatValue = (
  value: number | string | undefined,
  format?: (value: number) => string,
) => {
  if (value === undefined) return "—";
  if (typeof value === "number")
    return format ? format(value) : value.toLocaleString();
  return value;
};

export const StatCard = ({
  label,
  value,
  icon,
  colSpan = 2,
  rowSpan = 1,
  format,
}: StatCardProps) => (
  <DashboardCard
    colSpan={colSpan}
    rowSpan={rowSpan}
    sx={{
      flexDirection: "row",
      alignItems: "center",
      gap: "16px",
      padding: "16px 24px",
    }}
  >
    {icon && (
      <Box
        sx={{
          width: "44px",
          height: "44px",
          borderRadius: "12px",
          backgroundColor: "#F0FAFA",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
    )}
    <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
      <Typography
        sx={{
          fontSize: "28px",
          fontWeight: 700,
          lineHeight: 1,
          color: "#161447",
          letterSpacing: "-0.02em",
        }}
      >
        {formatValue(value, format)}
      </Typography>
      <Typography
        sx={{
          fontSize: "13px",
          fontWeight: 500,
          lineHeight: 1.2,
          color: "#5C5A74",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }}
      >
        {label}
      </Typography>
    </Box>
  </DashboardCard>
);
